import { Component } from '@angular/core';
import { WhyChoosePositivelyLanguagesReasonComponent } from './why-choose-positively-languages-reason/why-choose-positively-languages-reason.component';

@Component({
  standalone: true,
  imports: [WhyChoosePositivelyLanguagesReasonComponent],
  selector: 'lx-price-lists-portal-why-choose-positively-languages',
  templateUrl: './why-choose-positively-languages.component.html',
  styleUrls: ['./why-choose-positively-languages.component.scss', './print-why-choose-positively-languages.component.scss'],
})
export class WhyChoosePositivelyLanguagesComponent {}
